#import "./audience-stub-fragment.graphql"
#import "../../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

fragment Audience on Audience {
    ...AudienceStub
    creatorUser {
        id
        name
    }
    createdTime
    deletedTime
    publishedEditions(first: 1) {
        edges {
            node {
                id
                name
                scheduledTime
                htmlUrlPath
                status
                backgroundColor
                emailTemplate {
                    id
                    subject
                    thumbnailUrl
                }
                from {
                    ...FromAddress
                }
                audience {
                    id
                    name
                    htmlUrlPath
                }
                engagementStats {
                    totalSentCount
                    openRate
                    clickRate
                    permanentBounceRate
                }
                campaign {
                    id
                    name
                    type
                }
            }
        }
    }
    mostRecentSentEdition {
        id
        name
        scheduledTime
        htmlUrlPath
        status
        audience {
            id
            name
            htmlUrlPath
        }
        campaign {
            id
            name
            type
        }
        __typename
        ... on SmsEdition {
            content
            engagementStats {
                totalSentCount
                responseCount
                undeliveredRate
                optoutRate
            }
        }
        ... on Edition {
            backgroundColor
            emailTemplate {
                id
                subject
                thumbnailUrl
            }
            from {
                ...FromAddress
            }
            engagementStats {
                totalSentCount
                openRate
                clickRate
                permanentBounceRate
            }
        }
    }
}
